// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const AdobeIcon = createSvgIcon(
  <svg viewBox="0 0 200 200">
    <path fill="none" d="M0 0h200v200H0z" />
    <g fill="#fa0c00">
      <path d="M75.34 16.03H5.12v167.94zM124.75 16.03h70.13v167.94zM100.04 77.92l44.7 106.05h-29.32l-13.37-33.76h-32.7z" />
    </g>
  </svg>,
  "Adobe",
);
export default AdobeIcon;
